import HeaderProfile from '@tcs/client-portal-common/components/molecules/HeaderProfile';
import { useStyles } from './style';

const HeaderRail = () => {
  const classes = useStyles();
  return (
    <div className={classes.profile}>
      <HeaderProfile />
    </div>
  );
};

export default HeaderRail;
